// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"links_wrapper__IxbR0"};